import Axios from "axios";
import { useCallback, useRef } from "react";

const useAbortController = () => {
  const cancelTokenRef = useRef(Axios.CancelToken);
  const sourceRef = useRef(cancelTokenRef.current.source());

  const cancelPreviousRequest = useCallback(() => {
    sourceRef.current.cancel();
  }, []);

  const newCancelToken = useCallback(() => {
    cancelPreviousRequest();
    cancelTokenRef.current = Axios.CancelToken;
    sourceRef.current = cancelTokenRef.current.source();
    return sourceRef.current.token;
  }, [cancelPreviousRequest]);

  return {
    cancelPreviousRequest,
    newCancelToken,
    isCancelSource: Axios.isCancel,
  };
};

export default useAbortController;
